"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textDesktopStyle = exports.MaxLength = exports.Label = exports.FormGroup = exports.FormControlWrapper = exports.FormControl = void 0;

var _typography = require("../typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _typographyStyles = require("../typography/typography-styles");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Export `FormGroup` styled component.
 */
var FormGroup = _styledComponents["default"].div.withConfig({
  displayName: "fields-styled-components__FormGroup",
  componentId: "sc-nbgomp-0"
})(["margin-bottom:", ";position:relative;", " *{outline:none;}"], (0, _styledTools.ifProp)('hasAlert', '8px', '16px'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["cursor:default;pointer-events:none;"])));
/**
 * Export `FormControlWrapper` styled component.
 */


exports.FormGroup = FormGroup;

var FormControlWrapper = _styledComponents["default"].div.withConfig({
  displayName: "fields-styled-components__FormControlWrapper",
  componentId: "sc-nbgomp-1"
})(["align-items:center;background-color:", ";border:2px solid ", ";border-radius:", "px;column-gap:4px;display:flex;position:relative;transition:", ";transition-property:background-color,border-color;", " ", " ", " &:focus-visible{border-color:", ";outline:2px solid ", ";}&:hover{", "}"], (0, _styles.color)('gray300'), (0, _styles.color)('gray300'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _styles.color)('gray100'), (0, _styles.color)('gray100'))), (0, _styledTools.ifProp)('hasFocus', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('primary'))), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('danger'))), (0, _styles.color)('gray400'), (0, _styles.color)('blue200'), (0, _styledTools.ifProp)({
  disabled: false,
  hasError: false,
  hasFocus: false
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('gray400'))));
/**
 * Export `textDesktopStyle`.
 */


exports.FormControlWrapper = FormControlWrapper;
var textDesktopStyle = (0, _styledComponents.css)(["", ";font-size:16px;line-height:22px;"], _typographyStyles.typography.styles.textNormal);
/**
 * Text mobile style.
 */

exports.textDesktopStyle = textDesktopStyle;
var textMobileStyle = (0, _styledComponents.css)(["", ";font-size:12px;line-height:16px;"], _typographyStyles.typography.styles.textExtraSmall);
/**
 * Export `Label` styled component.
 */

var Label = _styledComponents["default"].label.withConfig({
  displayName: "fields-styled-components__Label",
  componentId: "sc-nbgomp-2"
})(["color:", ";left:10px;overflow:hidden;pointer-events:none;position:absolute;right:10px;text-overflow:ellipsis;top:13px;transform:translateY(0);transition:", ";transition-property:background-color,color,transform;white-space:nowrap;", " ", " ", ""], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isFloating', (0, _styledComponents.css)(["", " transform:translateY(-8px);"], textMobileStyle), (0, _styledComponents.css)(["", ""], textDesktopStyle)), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    left: 14px;\n    right: 14px;\n    top: 14px;\n\n    ", "\n  "])), (0, _styledTools.ifProp)('isFloating', (0, _styledComponents.css)(["transform:translateY(-10px);"]))));
/**
 * Export `FormControl` styled component.
 */


exports.Label = Label;

var FormControl = _styledComponents["default"].input.withConfig({
  displayName: "fields-styled-components__FormControl",
  componentId: "sc-nbgomp-3"
})(["", " background:none;border:0;box-shadow:none;color:", ";display:block;padding:20px 10px 6px;transition:color ", ";width:100%;", " ", " ", " &:disabled{color:", ";}"], textDesktopStyle, (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('danger'))), (0, _styledTools.ifProp)({
  as: 'textarea'
}, (0, _styledComponents.css)(["height:auto;resize:vertical;"])), _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-left: 14px;\n    padding-right: 14px;\n    padding-top: 22px;\n  "]))), (0, _styles.color)('gray400'));
/**
 * Export `MaxLength` styled component.
 */


exports.FormControl = FormControl;
var MaxLength = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'span',
  size: 'normal'
}).withConfig({
  displayName: "fields-styled-components__MaxLength",
  componentId: "sc-nbgomp-4"
})(["color:", ";padding:20px 10px 6px 0;position:relative;transition:color ", ";", " ", ""], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 4px;\n    padding-right: 14px;\n    padding-top: 22px;\n  "]))));
exports.MaxLength = MaxLength;